import React from 'react';
import { IconType } from 'react-icons';

export enum ButtonSizeEnum {
	SMALL = 'SMALL',
	MEDIUM = 'MEDIUM',
	LARGE = 'LARGE',
}

export enum IconPositionEnum {
	RIGHT = 'right',
	LEFT = 'left',
}

export enum ButtonVariantEnum {
	PRIMARY = 'primary',
	SECONDARY_DARK = 'secondaryDark',
	SECONDARY_LIGHT = 'secondaryLight',
	SUCCESS = 'success',
	WARNING = 'warning',
	ERROR = 'error',
	DISABLED = 'disabled',
}

// this is temporary
export enum ButtonWidthEnum {
	FULL = '100%',
}

export interface IButton {
	disabled?: boolean;
	variant?: ButtonVariantEnum;
	size?: ButtonSizeEnum;
	// width is temporary, I needed a full width button in the media library. Fabian will come up with a stretched button design, we should update it after that
	// make sure to update it here in the button.styles and in Sharing.js in the media library as well
	width?: ButtonWidthEnum;
	icon?: IconType;
	iconPosition?: IconPositionEnum;
	onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
	active?: boolean;
	type?: 'button' | 'submit' | 'reset';
}
